import { __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import ReportsServices from '@/modules/reports/ReportsServices';
var consumption = {};

var ConsumptionsReportModel =
/** @class */
function (_super) {
  __extends(ConsumptionsReportModel, _super);

  function ConsumptionsReportModel() {
    var _this = _super.call(this, consumption, ReportsServices) || this;

    _this.modelName = 'Reporte de Consumisiones';
    _this.request = 'JSON';
    return _this;
  }

  ConsumptionsReportModel.prototype.getAllConsumptionsReports = function (protocol) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getAllConsumptionsReports({
              query: protocol
            })];

          case 1:
            response = _a.sent();

            if (response && response.data) {
              return [2
              /*return*/
              , response.data];
            }

            return [2
            /*return*/
            , {
              data: [],
              total: 0,
              sum: 0
            }];
        }
      });
    });
  };

  return ConsumptionsReportModel;
}(BaseModel);

export default ConsumptionsReportModel;